import Vimeo from '@vimeo/player';

const docReady = (fn) => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

docReady(() => {
  const buttons = document.querySelectorAll(
    '.hero-play, .break-play, .deepsea-video--play, .hero--homepage-video .wp-block-button a',
  );

  Array.from(buttons).forEach((button) => {
    button.addEventListener('click', () => {
      // DOM is loaded and ready for manipulation here
      const modalSelector =
        button.dataset.videoId !== undefined
          ? `.videoModal[data-modal-video-id="${button.dataset.videoId}"]`
          : '.videoModal';
      const modal = document.querySelector(modalSelector);
      const siteHeader = document.querySelector('.site-header');

      const iframeSelector =
        button.dataset.videoId !== undefined
          ? `.videoModal[data-modal-video-id="${button.dataset.videoId}"] iframe`
          : '.videoModal iframe';
      const iframe = document.querySelector(iframeSelector);

      // Make sure elems exist before trying to use.
      if (!modal || !button || !iframe) {
        return;
      }

      const video = new Vimeo(iframe);
      const currentState = modal.style.display;
      const closeButtons = modal.querySelectorAll('.close-modal, .overlay');

      const closeModal = () => {
        modal.style.display = 'none';
        siteHeader.style.zIndex = null;
        video.pause();
      };

      if (currentState === 'none') {
        modal.style.display = 'block';
        siteHeader.style.zIndex = 1;

        Array.from(closeButtons).forEach((closeButton) => {
          closeButton.addEventListener('click', closeModal);
        });

        video.play();
      } else {
        modal.style.display = 'none';
        siteHeader.style.zIndex = null;

        Array.from(closeButtons).forEach((closeButton) => {
          closeButton.removeEventListener('click', closeModal);
        });

        video.pause();
      }
    });
  });
});
